// ============================================================================
// JAMB Learn Content — Biology
// Shared from WAEC learn bank (SS1+SS2+SS3 merged, no SS-level divisions shown)
// ============================================================================

import { WAEC_BIOLOGY_LEARN_SS1 } from '../../waec/learn/ss1/biology';
import { WAEC_BIOLOGY_LEARN_SS2 } from '../../waec/learn/ss2/biology';
import { WAEC_BIOLOGY_LEARN_SS3 } from '../../waec/learn/ss3/biology';

export const JAMB_LEARN_BIOLOGY = [
  ...WAEC_BIOLOGY_LEARN_SS1,
  ...WAEC_BIOLOGY_LEARN_SS2,
  ...WAEC_BIOLOGY_LEARN_SS3,
];
